"use client";

import { useEffect, useState } from "react";

type Props = {
  message: string;
  kind?: "success" | "error" | "info";
};

export default function Toast({ message, kind = "info" }: Props) {
  const [visible, setVisible] = useState(true);
  useEffect(() => {
    const t = setTimeout(() => setVisible(false), 5000);
    return () => clearTimeout(t);
  }, []);
  if (!visible) return null;
  const cls = kind === "success"
    ? "border-emerald-300 bg-emerald-50 text-emerald-800"
    : kind === "error"
    ? "border-rose-300 bg-rose-50 text-rose-800"
    : "border-amber-300 bg-amber-50 text-amber-800";
  return (
    <div className={`fixed top-4 right-4 z-50 max-w-sm border rounded-lg p-3 text-sm shadow-lg ${cls}`}>
      {message}
      <button
        onClick={() => setVisible(false)}
        aria-label="Dismiss"
        className="ml-3 text-neutral-500 hover:text-neutral-700"
      >
        ×
      </button>
    </div>
  );
}
